<template>
	<div class="nav">
		<img v-if="navBgImg == 'about'" src="../../assets/newimg/关于我们1.png" class="navimg">
		<img v-else-if="navBgImg == 'service'" src="../../assets/newimg/业务与服务.png" class="navimg">
		<img v-else-if="navBgImg == 'product'" src="../../assets/newimg/产品中心1.png" class="navimg">
		<img v-else-if="navBgImg == 'case'" src="../../assets/newimg/项目案例1.png" class="navimg">
		<img v-else-if="navBgImg == 'medium'" src="../../assets/newimg/新闻媒体1.png" class="navimg">
		<img v-else src="../../assets/newimg/联系我们.png" class="navimg">
		
		<div class="line" v-if="list.length > 1"></div>
		<div class="nav-c">
			
			<div class="nav-product" v-if="navBgImg == 'product'" style="text-align: left;width: fit-content;">
				Application Scenarios
				<!-- <div>Focus on new energy and power business<br>Provide customers with smart energy solutions</div> -->
			</div>
			<div class="nav-product" v-else-if="navBgImg == 'medium'" style="text-align: left;width: fit-content;">
				News Media
				<!-- <div>Witness together<br>The Growth Path of China Concept</div> -->
			</div>
			
			<div class="nav-case" v-else-if="navBgImg == 'case'" style="text-align: left;width: fit-content;">
				<span style="display: block;text-align: left;margin-left:-60px;">Project Case</span>
				<!-- <div>9 years of service accumulation</div> -->
			</div>
			<div class="nav-h nav-about1" v-else-if="navBgImg == 'about'" style="text-align: left;width: fit-content;">
				{{menutitle}}
			</div> 
			<div class="nav-case" v-else-if="navBgImg == 'service'" style="text-align: left;width: fit-content;">
				{{menutitle}}
			</div> 
			
			<div class="nav-h" v-else style="text-align: left;width: fit-content;">
				<!-- <img src="../../public/imgs/contactus/douhao.png" alt=""> -->
				{{menutitle}}
			</div>  
			
			<div class="nav-l" v-if="list.length > 1">
				<div class="item12" :class="navIndex==index?'selectItem':''" v-for="(item, index) in list" :key="index" @click="tapList(index)">
					{{item}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		props:{
			navBgImg:{
				type:String,
				default:""
			},
			list:{
				type:Array,
				default:[]
			},
			menutitle:{
				type:String,
				default:""
			},
			navIndex:{
				type:Number,
				default:0
			},
			current:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
	            selectIndex:0
			}
		},
		watch:{
			navIndex:{
				handler(newVal, oldVal) {
					this.selectIndex = newVal
					console.log(newVal, oldVal, "00000000")
				}
			}
		},
		created() {

		},
		methods: {
			tapList(index) {
				this.selectIndex = index
				this.$emit("tapMenu", index)
			}

		}
	}
</script>

<style lang="scss">
	.nav {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		.navimg {
			position:absolute;
			z-index:0;
		}
		.line {
			position: absolute;
			background-color: rgba(0, 0, 0, 0.4);
			z-index: 0;
		}
		.nav-c {
			position: relative;
			z-index: 3;
			.nav-h {
				color: #FFFFFF;
			}
			.nav-product {
				width: 100%;
				text-align: center;
				color: white;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
			.nav-l {
				display: flex;
				text-align: center;
				justify-content: flex-start;
				align-items: center;
				.item12 {
					cursor: pointer;
					color: white;
					border-bottom: 0;
				}
				.selectItem {
					border-bottom: 1px solid #62D4FF;
					color: #62D4FF;
				}
			}
		}
	}
	
	@media screen and (min-width: 1200px) {
		.nav {
			width: 100%;
			height: 500px;
			display: flex;
			.navimg {
				top:0;
				left:0;
				width: 100%;
				height: 500px;
				z-index:0;
			}
			.line {
				left: 0;
				bottom: 0;
				width: 100%;
				height: 56px;
			}
			.nav-c {
				width: 1200px;
				height: 500px;
				.nav-h {
					width: 100%;
					height: 444px;
					font-size: 36px;
					line-height: 444px;
				}
				.nav-about1 {
					// padding-top: 100px;
					padding-top:20px;
				}
				.nav-product {
					width: 100%;
					text-align: center;
					font-size: 36px;
					color: white;
					height: 444px;
					// line-height: 444px;
				}
				.nav-l {
					width: 100%;
					height: 56px;
					.item12 {
						// width: 80px; 
						font-size: 18px;
						padding-right: 20px;
						height: 56px;
						border-bottom: 0;
						line-height: 56px;
						margin-right: 60px;  
					}
					
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.nav {
			width: 100%;
			height: 400px;
			display: flex;
			.navimg {
				top:0;
				left:0;
				width: 100%;
				height: 400px;
				z-index:0;
			}
			.line {
				left: 0;
				bottom: 0;
				width: 100%;
				height: 50px;
			}
			.nav-c {
				width: 100%;
				height: 400px;
				padding: 0 20px;
				.nav-h {
					width: 100%;
					height: 350px;
					font-size: 30px;
					line-height: 350px;
				}
				.nav-product {
					width: 100%;
					text-align: center;
					font-size: 28px;
					color: white;
					height: 350px;
				}
				.nav-l {
					height: 50px;
					.item12 {
						font-size: 16px;
						padding-right:20px;
						height: 50px;
						border-bottom: 0;
						line-height: 50px;
						margin-right: 40px;  
					}
					
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.nav {
			width: 100%;
			height: 300px;
			display: flex;
			.navimg {
				top:0;
				left:0;
				width: 100%;
				height: 300px;
				z-index:0;
			}
			.line {
				left: 0;
				bottom: 0;
				width: 100%;
				height: 40px;
			}
			.nav-c {
				width: 100%;
				height: 300px;
				padding: 0 10px;
				.nav-h {
					width: 100%;
					height: 260px;
					font-size: 20px;
					line-height: 260px;
				}
				.nav-product {
					width: 100%;
					text-align: center;
					font-size: 16px;
					color: white;
					height: 260px;
				}
				.nav-l {
					height: 40px;
					.item12 {
						padding-right: 10px;
						font-size: 14px;
						height: 40px;
						border-bottom: 0;
						line-height: 40px;
						margin-right: 30px;  
					}
					
				}
			}
		}
	
	}
</style>
